import { render, staticRenderFns } from "./DateTimePicker.vue?vue&type=template&id=c1a0ddc8&scoped=true&lang=pug&"
import script from "./DateTimePicker.vue?vue&type=script&lang=js&"
export * from "./DateTimePicker.vue?vue&type=script&lang=js&"
import style0 from "./DateTimePicker.vue?vue&type=style&index=0&id=c1a0ddc8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a0ddc8",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/dateTimePicker.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FDateTimePicker.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports